/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const safety_glasses : {[key: string]: Array<[string, string]>} = {
};
